import { createContext, useContext } from 'react'

type SaveBarContextType = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  isDirty: boolean
  setIsDirty: (isDirty: boolean) => void
  hideAndRedirect: (url: string, method: 'push' | 'replace') => void
}

export const SaveBarContext = createContext<SaveBarContextType | undefined>(undefined)

export const useSaveBarContext = () => {
  const context = useContext(SaveBarContext)
  if (!context) {
    throw new Error('useSaveBarContext must be used within a SaveBarProvider')
  }
  return context
}
